export enum Permission {
    MENU_CONTROL_PLANE = 'menu:control_plane',
    MENU_CREATE_NAVIGATION_PANE = 'menu_create:navigation_pane',
    MENU_TRANSFORM_NAVIGATION_PANE = 'menu_transform:navigation_pane',
    MENU_INTEGRATE_NAVIGATION_PANE = 'menu_integrate:navigation_pane',
    MENU_REGISTER_NAVIGATION_PANE = 'menu_register:navigation_pane',
    MENU_PARTNER_INFO_NAVIGATION_PANE = 'menu_partner_info:navigation_pane',
    MENU_LEARN_NAVIGATION_PANE = 'menu_learn:navigation_pane',
    MENU_TEST_NAVIGATION_PANE = 'menu_test:navigation_pane',
    MENU_MANAGE_NAVIGATION_PANE = 'menu_manage:navigation_pane',
    MENU_TOOLS_NAVIGATION_PANE = 'menu_tools:navigation_pane',
    MENU_SAMPLES = 'menu:samples',
    MENU_SETTINGS_NAVIGATION_PANE = 'menu_settings:navigation_pane',
    MENU_SWITCH_TO = 'menu:switch_to',
    MENU_HISTORY = 'menu:history',
    MENU_DATA_ACCESS_API = 'menu:data_access_api',
    MENU_BUSINESS_LOGIC_API = 'menu:business_logic_api',
    MENU_THIRD_PARTY_API = 'menu:third_party_api',
    MENU_QUERY_BUILDER_API = 'menu:query_builder_api',
    MENU_TEST_SUITE_API = 'menu:test_suite_api',
    MENU_DATA_ACCESS_API_ADVANCED = 'menu:data_access_api_advanced',
    MENU_WORKFLOW_API = 'menu:workflow_api',
    MENU_SERVICE_PROVIDERS = 'menu:service_providers',
    MENU_SERVICE_PROVIDER_CATEGORIES = 'menu:service_provider_categories',
    MENU_API_TESTER = 'menu:api_tester',
    MENU_EMAIL_TEMPLATE_BUILDER = 'menu:email_template_builder',
    MENU_SCHEDULER = 'menu:scheduler',
    MENU_DATA_CATALOG = 'menu:data_catalog',
    MENU_FILE_MANAGER = 'menu:file_manager',
    MENU_BUSINESS_DETAILS = 'menu:business_details',
    MENU_DATABASES = 'menu:databases',
    MENU_BUSINESS_LOCATIONS = 'menu:business_locations',
    MENU_BRANDING = 'menu:branding',
    MENU_API_MANAGEMENT = 'menu:api_management',
    MENU_EMAIL_CONFIGURATIONS = 'menu:email_configurations',
    MENU_CONSUMER_GATEWAY_SETTINGS = 'menu:consumer_gateway_settings',
    MENU_MANAGE_USERS = 'menu:manage_users',
    MENU_MANAGE_USER_GROUPS = 'menu:user_groups',
    MENU_IDLE_TIMEOUT_SETTINGS = 'menu:idle_timeout_settings',
    MENU_DOCUMENTATION = 'menu:documentation',
    MENU_API_REGISTER = 'menu:api_register',
    MENU_TEST_RESULTS = 'menu:test_results',
    MENU_API_DISCOVERY = 'menu:api_discovery',
    MENU_JOURNEY_ANALYTICS = 'menu:journey_analytics',
    MENU_PLSQL_API = 'menu:plsql_api',
    MENU_DATA_TRANFORMATION_API = 'menu:datatransformation_api',
    MENU_DATA_TRANFORMATION_API_ADVANCED = 'menu:datatransformation_api',
    MENU_AUTHORIZATION_TYPES = 'menu:authorization_types',
    MENU_APIQL = 'menu:apiql',
    MENU_DATAQL = 'menu:dataql',

    CREATE_ENVIRONMENTS = 'create:environments',

    VIEW_SCHEDULAR = 'view:scheduler',
    EDIT_SCHEDULAR = 'edit:scheduler',
    DELETE_SCHEDULAR = 'delete:scheduler',

    // samples
    VIEW_DATAACCESS_API_SAMPLES = 'view_data_access_api:samples',
    FILTER_DATAACCESS_API_SAMPLES = 'filter_data_access_api:samples',
    PREVIEW_DATAACCESS_API_SAMPLES = 'preview_data_access_api:samples',
    VIEW_BUSINESS_LOGIC_API_SAMPLES = 'view_business_logic_api:samples',
    FILTER_BUSINESS_LOGIC_API_SAMPLES = 'filter_business_logic_api:samples',
    PREVIEW_BUSINESS_LOGIC_API_SAMPLES = 'preview_business_logic_api:samples',
    VIEW_QUERY_BUILDER_SAMPLES = 'view_query_builder:samples',
    FILTER_QUERY_BUILDER_SAMPLES = 'filter_query_builder:samples',
    PREVIEW_QUERY_BUILDER_SAMPLES = 'preview_query_builder:samples',

    UPLOAD_LOGO_MARK_BRANDING = 'upload_logo_mark:branding',
    UPLOAD_BRAND_IMAGE_BRANDING = 'upload_brand_image:branding',
    DELETE_LOGO_MARK_BRANDING = 'delete_logo_mark:branding',
    DELETE_BRAND_IMAGE_BRANDING = 'delete_brand_image:branding',
    VIEW_BUSINESS_DETAILS = 'view:business_details',
    EDIT_BUSINESS_DETAILS = 'edit:business_details',
    VIEW_BUSINESS_LOCATIONS = 'view:business_locations',
    EDIT_BUSINESS_LOCATIONS = 'edit:business_locations',
    VIEW_LOGO_MARK = 'view_logo_mark:branding',
    VIEW_BRAND_IMAGE = 'view_brand_image:branding',

    // databases
    VIEW_DATABASES = 'view:databases',
    DELETE_DATABASES = 'delete:databases',
    TEST_DATABASES = 'test:databases',
    ADD_DATABASES_FROM_APIPLATFORM_DATABASES = 'add_databases_from_apiplatform:databases',
    ADD_EXTERNAL_DATABASES_DATABASES = 'add_external_databases:databases',
    EDIT_DATABASE_CONNECTION = 'edit_database_connection:databases',

    // file manager
    FILTER_FILE_MANAGER = 'filter:file_manager',
    UPLOAD_FILE_FILE_MANAGER = 'upload_file:file_manager',
    UPLOAD_FOLDER_FILE_MANAGER = 'upload_folder:file_manager',
    CREATE_FOLDER_FILE_MANAGER = 'create_folder:file_manager',
    DELETE_FILE_FILE_MANAGER = 'delete_file:file_manager',
    DELETE_FOLDER_FILE_MANAGER = 'delete_folder:file_manager',
    DOWNLOAD_FILE_FILE_MANAGER = 'download_file:file_manager',
    VIEW_FILE_MANAGER = 'view:file_manager',

    // service providers
    VIEW_MY_API_PROVIDERS_SERVICE_PROVIDERS = 'view_my_api_providers:service_providers',
    VIEW_ALL_API_PROVIDERS_SERVICE_PROVIDERS = 'view_all_api_providers:service_providers',
    FILTER_MY_API_PROVIDERS_SERVICE_PROVIDERS = 'filter_my_api_providers:service_providers',
    ADD_SERVICE_PROVIDERS = 'add:service_providers',
    ACTIVATE_SERVICE_PROVIDERS = 'activate:service_providers',
    MANAGE_SERVICE_PROVIDERS = 'manage:service_providers',
    FILTER_SERVICE_PROVIDER_CATEGORIES = 'filter:service_provider_categories',
    DEACTIVATE_SERVICE_PROVIDERS = 'deactivate:service_providers',
    ADD_SERVICE_PROVIDER_CATEGORIES = 'add:service_provider_categories',
    VIEW_LIST_SERVICE_PROVIDER_CATEGORIES = 'view_list:service_provider_categories',
    CREATE_SERVICE_PROVIDER_CONNECTORS = 'create:service_provider_connectors',
    TEST_SERVICE_PROVIDER_CONNECTORS = 'test:service_provider_connectors',
    DELETE_SERVICE_PROVIDER_CONNECTORS = 'delete:service_provider_connectors',
    VIEW_SERVICE_PROVIDER_CONNECTORS = 'view:service_provider_connectors',
    MENU_SERVICE_PROVIDER_CONNECTORS = 'menu:service_provider_connectors',
    VIEW_APIS_SERVICE_PROVIDERS = 'view_apis:service_providers',
    VIEW_CONNECTORS_SERVICE_PROVIDERS = 'menu:service_provider_connectors',
    VIEW_SERVICE_PROVIDER_CATEGORIES = 'view:service_provider_categories',

    // email template builder
    CREATE_EMAIL_TEMPLATE = 'create_email_template:email_template_builder',
    DELETE_EMAIL_TEMPLATE = 'delete_email_template:email_template_builder',
    EDIT_EMAIL_TEMPLATE = 'edit_email_template:email_template_builder',
    EXECUTE_EMAIL_TEMPLATE = 'execute_email_template:email_template_builder',
    VIEW_EMAIL_TEMPLATE = 'view_email_template:email_template_builder',
    SCHEDULE_EMAIL = 'schedule_email:email_template_builder',
    VIEW_EXECUTE = 'view_execute:email_template_builder',
    VIEW_MANAGE_EMAIL_TEMPLATE_BUILDER = 'view_manage:email_template_builder',

    // kong gateway permissions
    CREATE_CONSUMER_CONSUMER_GATEWAY_SETTINGS = 'create_consumer:consumer_gateway_settings',
    DELETE_CONSUMER_CONSUMER_GATEWAY_SETTINGS = 'delete_consumer:consumer_gateway_settings',
    EDIT_CONSUMER_CONSUMER_GATEWAY_SETTINGS = 'edit_consumer:consumer_gateway_settings',
    VIEW_CONSUMERS_CONSUMER_GATEWAY_SETTINGS = 'view_consumers:consumer_gateway_settings',
    FILTER_CONSUMERS_CONSUMER_GATEWAY_SETTINGS = 'filter_consumers:consumer_gateway_settings',
    CREATE_BASIC_CONSUMER_CREDENTIALS = 'create_basic:consumer_credentials',
    DELETE_BASIC_CONSUMER_CREDENTIALS = 'delete_basic:consumer_credentials',
    VIEW_BASIC_CONSUMER_CREDENTIALS = 'view_basic:consumer_credentials',
    CREATE_OAUTH_CONSUMER_CREDENTIALS = 'create_oauth:consumer_credentials',
    DELETE_OAUTH_CONSUMER_CREDENTIALS = 'delete_oauth:consumer_credentials',
    VIEW_OAUTH_CONSUMER_CREDENTIALS = 'view_oauth:consumer_credentials',
    CREATE_JWT_CONSUMER_CREDENTIALS = 'create_jwt:consumer_credentials',
    VIEW_JWT_CONSUMER_CREDENTIALS = 'view_jwt:consumer_credentials',
    CREATE_HMAC_CONSUMER_CREDENTIALS = 'create_hmac:consumer_credentials',
    DELETE_HMAC_CONSUMER_CREDENTIALS = 'delete_hmac:consumer_credentials',
    CREATE_APIKEY_CONSUMER_CREDENTIALS = 'create_apikey:consumer_credentials',
    DELETE_APIKEY_CONSUMER_CREDENTIALS = 'delete_apikey:consumer_credentials',
    VIEW_APIKEY_CONSUMER_CREDENTIALS = 'view_apikey:consumer_credentials',
    DELETE_JWT_CONSUMER_CREDENTIALS = 'delete_jwt:consumer_credentials',
    VIEW_HMAC_CONSUMER_CREDENTIALS = 'view_hmac:consumer_credentials',
    VIEW_ACCESS_CONTROL_LIST = 'view:access_control_list',

    VIEW_PLUGINS_API_MANAGEMENT = 'view_plugins:api_management',
    EDIT_PLUGINS_API_MANAGEMENT = 'edit_plugins:api_management',
    ADD_PLUGINS_API_MANAGEMENT = 'add_plugins:api_management',
    VIEW_SERVICES_API_MANAGEMENT = 'view_services:api_management',
    DELETE_PLUGINS_API_MANAGEMENT = 'delete_plugins:api_management',
    VIEW_ROUTES_API_MANAGEMENT = 'view_routes:api_management',

    // rbac
    CREATE_PERMISSIONS = 'create:permissions',
    VIEW_PERMISSIONS = 'view:permissions',
    CREATE_PERMISSION_GROUPS = 'create:permission_groups',
    VIEW_PERMISSION_GROUPS = 'view:permission_groups',
    UPDATE_PERMISSION_GROUPS = 'update:permission_groups',
    DELETE_PERMISSION_GROUPS = 'delete:permission_groups',
    CREATE_ROLES = 'create:roles',
    DELETE_ROLES = 'delete:roles',
    VIEW_USERS = 'view:users',
    DELETE_USER_MANAGE_USERS = 'delete_user:manage_users',
    MENU_PERMISSIONS = 'menu:permissions',
    MENU_PERMISSION_GROUPS = 'menu:permission_groups',
    MENU_ROLES = 'menu:roles',
    UPDATE_PERMISSIONS = 'update:permissions',
    DELETE_PERMISSIONS = 'delete:permissions',
    VIEW_ROLES = 'view:roles',
    UPDATE_ROLES = 'update:roles',
    VIEW_MANAGE_USERS = 'view:manage_users',
    CREATE_USER_MANAGE_USERS = 'create_user:manage_users',
    EDIT_USER_ROLE_MANAGE_USERS = 'edit_user_role:manage_users',
    EDIT_USER_PERMISSIONS_MANAGE_USERS = 'edit_user_permissions:manage_users',
    RESET_USER_PASSWORD_MANAGE_USERS = 'reset_user_password:manage_users',
    FILTER_USERS_MANAGE_USERS = 'filter_users:manage_users',
    ADD_ENVIRONMENT_MANAGE_USERS = 'add_environment:manage_users',
    DELETE_ENVIRONMENT_MANAGE_USERS = 'delete_environment:manage_users',

    // admin console
    DISABLE_ENVIRONMENTS = 'disable:environments',
    ENABLE_ENVIRONMENTS = 'enable:environments',
    DELETE_ENVIRONMENTS = 'delete:environments',
    VIEW_AUDIT_LOGS_SECRETS_MANAGER = 'view_audit_logs:secrets_manager',
    VIEW_AUDIT_LOGS_API_GATEWAY_MANAGER = 'view_audit_logs:api_gateway_manager',
    VIEW_AUDIT_LOGS_S3_BUCKET_CONNECTOR = 'view_audit_logs:s3_bucket_connector',
    VIEW_AUDIT_LOGS_STORAGE = 'view_audit_logs:storage',
    VIEW_AUDIT_LOGS_PLATFORM_CONSOLE = 'view_audit_logs:platform_console',
    VIEW_AUDIT_LOGS_DEVELOPER_EXPERIENCE = 'view_audit_logs:developer_experience',
    VIEW_AUDIT_LOGS_IDLE_TIMEOUT_SETTINGS = 'view_audit_logs:idle_timeout_settings',
    VIEW_AUDIT_LOGS_EMAIL_CONFIGURATIONS = 'view_audit_logs:email_configurations',
    VIEW_AUDIT_LOGS_DATABASES = 'view_audit_logs:databases',

    // email configurations
    CREATE_EMAIL_CONFIGURATIONS = 'create:email_configurations',
    TEST_EMAIL_CONFIGURATIONS = 'test:email_configurations',
    EDIT_EMAIL_CONFIGURATIONS = 'edit:email_configurations',
    VIEW_EMAIL_CONFIGURATIONS = 'view:email_configurations',
    DELETE_EMAIL_CONFIGURATIONS = 'delete:email_configurations',

    // history
    VIEW_HISTORY = 'view:history',
    FILTER_HISTORY = 'filter:history',
    EDIT_HISTORY = 'edit:history',

    // secrets manager
    ADD_SECRETS_MANAGER_SECRETS_MANAGER = 'add_secrets_manager:secrets_manager',
    ADD_SECRETS_SECRETS_MANAGER = 'add_secrets:secrets_manager',
    VIEW_SECRETS_MANAGER = 'view:secrets_manager',

    // idle timeout setting
    EDIT_IDLE_TIMEOUT_SETTINGS = 'edit:idle_timeout_settings',
    VIEW_IDLE_TIMEOUT_SETTINGS = 'view:idle_timeout_settings',

    VIEW_S3_BUCKET_CONNECTOR = 'view:s3_bucket_connector',

    PLAY_VIDEO_DATAACCESS_API_SAMPLES = 'play_video_data_access_api:samples',
    PLAY_VIDEO_BUSINESSLOGIC_API_SAMPLES = 'play_video_business_logic_api:samples',
    PLAY_VIDEO_QUERYBUILDER_SAMPLES = 'play_video_query_builder:samples',

    VIEW_STATISTICS_CONTROL_PLANE = 'view_statistics:control_plane',
    VIEW_API_DASHBOARD = 'view_api_dashboard:control_plane',
    CONTROL_PLANE_FILTER = 'filter:control_plane',
    CONTROL_PLANE_VIEW_OPERATIONAL_METRICS = 'view_operational_metrics:control_plane',
    CREATE_DATA_ACCESS_API = 'create:data_access_api',
    EDIT_DATA_ACCESS_API = 'edit:data_access_api',
    PROMOTE_DATA_ACCESS_API = 'promote:data_access_api',
    VIEW_DATA_ACCESS_API = 'view:data_access_api',
    PUBLISH_DATA_ACCESS_API = 'publish:data_access_api',
    COPY_DATA_ACCESS_API = 'copy:data_access_api',
    SAVE_DATA_ACCESS_API = 'save:data_access_api',
    DELETE_DATA_ACCESS_API = 'delete:data_access_api',
    METRICS_DATA_ACCESS_API = 'metrics:data_access_api',
    SHOW_ENDPOINTS_DATA_ACCESS_API = 'show_endpoints:data_access_api',
    GRANT_ACCESS_DATA_ACCESS_API = 'grant_access:data_access_api',
    CREATE_DATA_ACCESS_API_ADVANCED = 'create:data_access_api_advanced',
    VIEW_DATA_ACCESS_API_ADVANCED = 'view:data_access_api_advanced',
    EDIT_DATA_ACCESS_API_ADVANCED = 'edit:data_access_api_advanced',
    DATA_STORAGE_DATA_ACCESS_API_ADVANCED = 'data_storage:data_access_api_advanced',
    FOREIGN_KEY_DATA_ACCESS_API_ADVANCED = 'foreign_key:data_access_api_advanced',
    METHOD_DEFINITION_DATA_ACCESS_API_ADVANCED = 'method_definition:data_access_api_advanced',
    CACHE_DATA_ACCESS_API_ADVANCED = 'cache:data_access_api_advanced',
    PUBLISH_DATA_ACCESS_API_ADVANCED = 'publish:data_access_api_advanced',
    SAVE_DATA_ACCESS_API_ADVANCED = 'save:data_access_api_advanced',
    API_GATEWAY_DATA_ACCESS_API_ADVANCED = 'api_gateway:data_access_api_advanced',
    VIEW_DATA_DATA_MANAGEMENT = 'view_data:data_management',
    INSERT_DATA_DATA_MANAGEMENT = 'insert_data:data_management',
    EDIT_DATA_DATA_MANAGEMENT = 'edit_data:data_management',
    DELETE_DATA_DATA_MANAGEMENT = 'delete_data:data_management',
    IMPORT_DATA_DATA_MANAGEMENT = 'import_data:data_management',
    EXPORT_DATA_DATA_MANAGEMENT = 'export_data:data_management',
    VIEW_JSON_DATA_MANAGEMENT = 'view_json:data_management',
    FILTER_ATTRIBUTES_DATA_MANAGEMENT = 'filter_attributes:data_management',
    ENABLE_ADVANCED_SEARCH_DATA_MANAGEMENT = 'enable_advanced_search:data_management',
    REFRESH_DATA_DATA_MANAGEMENT = 'refresh_data:data_management',

    CHANGE_ENVIRONMENTS_SWITCH_TO = 'change_environments:switch_to',
    SHOW_ENVIRONMENTS_SWITCH_TO = 'show_environments:switch_to',

    CREATE_SCHEDULER = 'create:scheduler',
    CREATE_BUSINESS_LOGIC_API = 'create:business_logic_api',
    EDIT_BUSINESS_LOGIC_API = 'edit:business_logic_api',
    PROMOTE_BUSINESS_LOGIC_API = 'promote:business_logic_api',
    DELETE_BUSINESS_LOGIC_API = 'delete:business_logic_api',
    PUBLISH_BUSINESS_LOGIC_API = 'publish:business_logic_api',
    TEST_BUSINESS_LOGIC_API = 'test:business_logic_api',
    SAVE_BUSINESS_LOGIC_API = 'save:business_logic_api',
    COPY_BUSINESS_LOGIC_API = 'copy:business_logic_api',
    UPDATE_PARAMS_BUSINESS_LOGIC_API = 'update_params:business_logic_api',
    SHOW_ENDPOINTS_BUSINESS_LOGIC_API = 'show_endpoints:business_logic_api',
    GRANT_ACCESS_BUSINESS_LOGIC_API = 'grant_access:business_logic_api',

    CREATE_QUERY_BUILDER_API = 'create:query_builder_api',
    EDIT_QUERY_BUILDER_API = 'edit:query_builder_api',
    PROMOTE_QUERY_BUILDER_API = 'promote:query_builder_api',
    DELETE_QUERY_BUILDER_API = 'delete:query_builder_api',
    PUBLISH_QUERY_BUILDER_API = 'publish:query_builder_api',
    SAVE_QUERY_BUILDER_API = 'save:query_builder_api',
    COPY_QUERY_BUILDER_API = 'copy:query_builder_api',
    SHOW_ENDPOINTS_QUERY_BUILDER_API = 'show_endpoints:query_builder_api',
    GRANT_ACCESS_QUERY_BUILDER_API = 'grant_access:query_builder_api',
    VIEW_QUERY_BUILDER_API = 'view:query_builder_api',

    CREATE_UNIFIED_QUERY_API = 'create:unified_query_api',
    EDIT_UNIFIED_QUERY_API = 'edit:unified_query_api',
    PROMOTE_UNIFIED_QUERY_API = 'promote:unified_query_api',
    DELETE_UNIFIED_QUERY_API = 'delete:unified_query_api',
    PUBLISH_UNIFIED_QUERY_API = 'publish:unified_query_api',
    SAVE_UNIFIED_QUERY_API = 'save:unified_query_api',
    COPY_UNIFIED_QUERY_API = 'copy:unified_query_api',
    SHOW_ENDPOINTS_UNIFIED_QUERY_API = 'show_endpoints:unified_query_api',
    GRANT_ACCESS_UNIFIED_QUERY_API = 'grant_access:unified_query_api',

    CREATE_PLSQL_API = 'create:plsql_api',
    EDIT_PLSQL_API = 'edit:plsql_api',
    PROMOTE_PLSQL_API = 'promote:plsql_api',
    DELETE_PLSQL_API = 'delete:plsql_api',
    PUBLISH_PLSQL_API = 'publish:plsql_api',
    SAVE_PLSQL_API = 'save:plsql_api',
    COPY_PLSQL_API = 'copy:plsql_api',
    SHOW_ENDPOINTS_PLSQL_API = 'show_endpoints:plsql_api',
    GRANT_ACCESS_PLSQL_API = 'grant_access:plsql_api',

    CREATE_DATA_TRANSFORM_API = 'create:datatransformation_api',
    EDIT_DATA_TRANSFORM_API = 'edit:datatransformation_api',
    PROMOTE_DATA_TRANSFORM_API = 'promote:datatransformation_api',
    DELETE_DATA_TRANSFORM_API = 'delete:datatransformation_api',
    PUBLISH_DATA_TRANSFORM_API = 'publish:datatransformation_api',
    SAVE_DATA_TRANSFORM_API = 'save:datatransformation_api',
    COPY_DATA_TRANSFORM_API = 'copy:datatransformation_api',
    SHOW_ENDPOINTS_DATA_TRANSFORM_API = 'show_endpoints:datatransformation_api',
    GRANT_ACCESS_DATA_TRANSFORM_API = 'grant_access:datatransformation_api',

    VIEW_DATA_CATALOG = 'view:data_catalog',
    VIEW_CONN_DATA_CATALOG = 'view_connection_details:data_catalog',
    VIEW_PROPERTIES_DATA_CATALOG = 'view_properties:data_catalog',
    VIEW_ER_DATA_CATALOG = 'view_ER_diagram:data_catalog',
    VIEW_DICT_DATA_CATALOG = 'view_dictionary:data_catalog',
    VIEW_LINEAGE_PATH_DATA_CATALOG = 'view_data_lineage_path:data_catalog',
    DIGITAL_TRANSFORMER_DATA_CATALOG = 'digital_transformer:data_catalog',
    VIEW_DATA_DATA_CATALOG = 'view_data:data_catalog',
    VIEW_DEFINITION_DATA_CATALOG = 'view_definition:data_catalog',

    VIEW_API_GATEWAY_MANAGER = 'view:api_gateway_manager',
    DELETE_API_GATEWAY_MANAGER = 'delete:api_gateway_manager',

    VIEW_WORKFLOW_API = 'view:workflow_api',
    CREATE_WORKFLOW_API = 'create:workflow_api',
    EDIT_WORKFLOW_API = 'edit:workflow_api',
    PROMOTE_WORKFLOW_API = 'promote:workflow_api',
    DELETE_WORKFLOW_API = 'delete:workflow_api',
    PUBLISH_WORKFLOW_API = 'publish:workflow_api',
    SAVE_WORKFLOW_API = 'save:workflow_api',
    COPY_WORKFLOW_API = 'copy:workflow_api',
    SHOW_ENDPOINTS_WORKFLOW_API = 'show_endpoints:workflow_api',
    GRANT_ACCESS_WORKFLOW_API = 'grant_access:workflow_api',
    DESIGNER_WORKFLOW_API = 'designer:workflow_api',
    OUTPUT_WORKFLOW_API = 'output:workflow_api',
    LOCAL_BPMN_DOWNLOAD_WORKFLOW_API = 'local_bpmn_download:workflow_api',
    LOCAL_SVG_IMAGE_WORKFLOW_API = 'local_svg_image:workflow_api',
    IMPORT_FROM_S3_WORKFLOW_API = 'import_from_s3:workflow_api',
    BLANK_DIAGRAM_WORKFLOW_API = 'blank_diagram:workflow_api',

    CREATE_TEST_SUITE_API = 'create:test_suite_api',
    EDIT_TEST_SUITE_API = 'edit:test_suite_api',
    PROMOTE_TEST_SUITE_API = 'promote:test_suite_api',
    DELETE_TEST_SUITE_API = 'delete:test_suite_api',
    PUBLISH_TEST_SUITE_API = 'publish:test_suite_api',
    TEST_TEST_SUITE_API = 'test:test_suite_api',
    SAVE_TEST_SUITE_API = 'save:test_suite_api',
    CREATE_TEAR_DOWN_TEST_SUITE_API = 'create_tear_down:test_suite_api',
    EDIT_TEAR_DOWN_TEST_SUITE_API = 'edit_tear_down:test_suite_api',
    ADD_TEST_CASE_TEST_SUITE_API = 'add_test_case:test_suite_api',
    EDIT_TEST_CASE_TEST_SUITE_API = 'edit_test_case:test_suite_api',
    DELETE_TEST_CASE_TEST_SUITE_API = 'delete_test_case:test_suite_api',
    ADD_RULE_TEST_SUITE_API = 'add_rule:test_suite_api',
    EDIT_RULE_TEST_SUITE_API = 'edit_rule:test_suite_api',
    DELETE_RULE_TEST_SUITE_API = 'delete_rule:test_suite_api',
    SHOW_API_BROWSER_TEST_SUITE_API = 'show_api_browser:test_suite_api',
    CREATE_PRE_STEPS_TEST_SUITE_API = 'create_pre_steps:test_suite_api',
    EDIT_PRE_STEPS_TEST_SUITE_API = 'edit_pre_steps:test_suite_api',
    SHOW_ENDPOINTS_TEST_SUITE_API = 'show_endpoints:test_suite_api',
    GRANT_ACCESS_TEST_SUITE_API = 'grant_access:test_suite_api',
    VIEW_TEST_RESULTS = 'view:test_results',

    CREATE_THIRD_PARTY_API = 'create:third_party_api',
    EDIT_THIRD_PARTY_API = 'edit:third_party_api',
    PROMOTE_THIRD_PARTY_API = 'promote:third_party_api',
    DELETE_THIRD_PARTY_API = 'delete:third_party_api',
    GRANT_ACCESS_THIRD_PARTY_API = 'grant_access:third_party_api',

    PUBLISH_API_DOCUMENTATION = 'publish_api:documentation',
    EXECUTE_API_DOCUMENTATION = 'execute_api:documentation',

    VIEW_API_TESTER = 'view:api_tester',
    TEST_API_TESTER = 'test:api_tester',
    EXECUTE_API_TESTER = 'execute:api_tester',
    REGISTER_API_TESTER = 'register:api_tester',
    UPDATE_API_TESTER = 'update:api_tester',

    VIEW_PARTNER_SHORTCODE_PARTNER_DETAILS = 'view_partner_short_code:partner_details',
    VIEW_PRIMARY_EMAIL_PARTNER_DETAILS = 'view_primary_email:partner_details',
    VIEW_CURRENT_PLAN_PARTNER_DETAILS = 'view_current_plan:partner_details',
    VIEW_PARTNER_KEY_PARTNER_DETAILS = 'view_partner_key:partner_details',
    COPY_PARTNER_KEY_PARTNER_DETAILS = 'copy_partner_key:partner_details',
    VIEW_API_KEY_PARTNER_DETAILS = 'view_api_key:partner_details',
    COPY_API_KEY_PARTNER_DETAILS = 'copy_api_key:partner_details',

    VIEW_DOCUMENTATION = 'view:documentation',

    VIEW_API_REGISTER = 'view:api_register',
    REGISTER_API_REGISTER = 'register:api_register',
    CLEAR_FIELDS_API_REGISTER = 'clear_fields:api_register',

    VIEW_API_DISCOVERY = 'view:api_discovery',

    VIEW_JOURNEY_ANALYTICS = 'view:journey_analytics',
    SELECT_PARTNER_JOURNEY_ANALYTICS = 'select_partner:journey_analytics',
    SELECT_ENVIRONMENT_JOURNEY_ANALYTICS = 'select_environment:journey_analytics',
    SELECT_USER_JOURNEY_ANALYTICS = 'select_user:journey_analytics',

    MENU_BILLING = 'menu:billing',
    VIEW_BILLING = 'view_bills:billing',
    APPLY_COUPON = 'apply_coupon:billing',
    PAY_BILL = 'pay_bills:billing',
    DOWNLOAD_INVOICE = 'download_bills:billing',

    MENU_API_REFERENCE = 'menu:api_reference',
    VIEW_API_REFERENCE = 'view:api_reference',
    ADD_PAGE_API_REFERENCE = 'add_page:api_reference',
    EDIT_PAGE_API_REFERENCE = 'edit_page:api_reference',
    DELETE_PAGE_API_REFERENCE = 'delete_page:api_reference',

    VIEW_AUTHORIZATION_TYPES = 'view:authorization_types',
    EDIT_AUTHORIZATION_TYPES = 'edit:authorization_types',

    VIEW_APIQL = 'view:apiql',
    TEST_APIQL = 'test:apiql',

    VIEW_DATAQL = 'view:dataql',
    TEST_DATAQL = 'test:dataql',

    MENU_ACCELERATORS = 'menu:accelerators',
    VIEW_ACCELERATORS = 'view:accelerators',
    EDIT_ACCELERATORS = 'edit:accelerators',

    MENU_ALERTS = 'menu:alerts',
    VIEW_ALERTS = 'view:alerts',
    EDIT_ALERTS = 'edit:alerts',
    ADD_ALERTS = 'add:alerts',
    DELETE_ALERTS = 'delete:alerts',

    MENU_MONITORS = 'menu:api_monitoring',
    VIEW_MONITORS = 'view:api_monitoring',

}
